import { GameID } from '@/enums/gameId';
import { useGameReportData } from '@/hooks/gameReport/useGameReportData';
import { useGameReportSearchParams } from '@/hooks/gameReport/useGameReportSearchParams';
import { DetailedGameRound } from '@/models/detailed-round';
import CrashGameReportBoard from './Crash';
import DoubleGameReportBoard from './Double';
import FortuneDoubleGameReportBoard from './FortuneDouble';
import SlideGameReportBoard from './Slide';

export default function GameDetailsContentBoardRound() {
  const { gameId } = useGameReportSearchParams();
  const { round } = useGameReportData();

  switch (gameId?.toString()) {
    case GameID.Crash?.toString():
    case GameID.CrashTrenball?.toString():
      return <CrashGameReportBoard round={round as DetailedGameRound} />;
    case GameID.Slide?.toString():
      return <SlideGameReportBoard round={round as DetailedGameRound} />;
    case GameID.Frost?.toString():
      return (
        <FortuneDoubleGameReportBoard round={round as DetailedGameRound} />
      );
    case GameID.Double?.toString():
      return <DoubleGameReportBoard round={round as DetailedGameRound} />;
  }
}
